import axios from 'axios';
import _ from 'lodash';

// config
const request = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASEURL,
});

const headers = (header) => {
  return {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('api_key')}`,
      ...header && header,
    }
  };
};

const getHotelId = () => {
  return localStorage.getItem('hotel_id');
}

const querystring = (query) => {
  return {
    params: query
  };
};

const removeNullInObject = (obj) => {
  return _.pickBy(obj, function (value, key) {
    return !_.isEmpty(value);
  });
}

// login
export const login = ({phoneNumber:phone_number, password}) => {
  const data = {phone_number, password};
  return request.post('/multifamily/staff/session', data);
}

export const logout = () => {
  return request.delete('/multifamily/staff/session', headers());
}

// hotel
export const createHotel = ({name, timezone, address, desc, pincodeDayTypeOffset:pincode_day_type_offset, commonrooms}) => {
  const data = {name, timezone, address, desc, pincode_day_type_offset, commonrooms};
  return request.post('/multifamily/hotels/',
    data,
    headers(),
  );
}

export const createFacilityByExcelUpload = ({file}) => {
  const data = file;
  return request.post(`/multifamily/facilities/bulk`,
    data,
    headers({'Content-Type': 'multipart/form-data'}),
  );
}

export const selectHotel = () => {
  return request.get(`/multifamily/hotels/${getHotelId()}`, headers());
}

export const listHotel = ({name, offset, limit, pagination=true}) => {
  return request.get('/multifamily/hotels', {
    ...querystring({...name && {name}, offset, limit, pagination}),
    ...headers(),
  });
}

export const updateHotel = ({name, timezone, address, desc, pincodeDayTypeOffset:pincode_day_type_offset, commonrooms}) => {
  let data = removeNullInObject({name, timezone, address, pincode_day_type_offset});
  data = {...data, desc, commonrooms};
  return request.put(`/multifamily/hotels/${getHotelId()}`,
    data,
    headers(),
  );
}

export const deleteHotel = () => {
  return request.delete(`/multifamily/hotels/${getHotelId()}`, headers());
}

// buildingtype
export const listBuildingtype = () => {
  return request.get('/multifamily/hotels/buildingtypes', {
    // ...querystring({}),
    ...headers(),
  });
}

// building
export const createBuilding = ({name, buildingtypeId:buildingtype_id, commonrooms}) => {
  const data = removeNullInObject({name, buildingtype_id, commonrooms});
  return request.post(`/multifamily/hotels/${getHotelId()}/buildings`,
    data,
    headers(),
  );
}

export const selectBuilding = ({buildingId:building_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}`, headers());
}

export const listBuilding = ({name, offset, limit, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings`, {
    ...querystring({...name && {name}, offset, limit, pagination}),
    ...headers(),
  });
}

export const updateBuilding = ({buildingId:building_id, name, buildingtypeId:buildingtype_id, commonrooms}) => {
  let data = removeNullInObject({name, buildingtype_id});
  data= {...data, commonrooms};
  return request.put(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}`,
    data,
    headers(),
  );
}

export const deleteBuilding = ({buildingId:building_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}`, headers());
}

// floor
export const createFloor = ({buildingId:building_id, name}) => {
  const data = removeNullInObject({name});
  return request.post(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors`,
    data,
    headers(),
  );
}

export const selectFloor = ({buildingId:building_id, floorId:floor_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}`, headers());
}

export const listFloor = ({buildingId:building_id, offset, limit, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors`, {
    ...querystring({offset, limit, pagination}),
    ...headers(),
  });
}

export const updateFloor = ({buildingId:building_id, floorId:floor_id, name}) => {
  let data = removeNullInObject({name});
  return request.put(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}`,
    data,
    headers(),
  );
}

export const deleteFloor = ({buildingId:building_id, floorId:floor_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}`, headers());
}

// room
export const createRoom = ({buildingId:building_id, floorId:floor_id, name, rmsId:rms_id, allowKeytag:allow_keytag, advertiseStrength:advertise_strength, connectedStrength:connected_strength}) => {
  let data = removeNullInObject({name, rms_id});
  data = {...data, allow_keytag, ...allow_keytag && {advertise_strength, connected_strength}};
  return request.post(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}/rooms`,
    data,
    headers(),
  );
}

export const selectRoom = ({buildingId:building_id, floorId:floor_id, roomId:room_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}/rooms/${room_id}`, headers());
}

export const selectRoomId = ({buildingId:building_id, roomId:room_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/rooms/${room_id}`, headers({}));
}

export const listRoom = ({buildingId:building_id, offset, limit, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/rooms`, {
    ...querystring({offset, limit, pagination}),
    ...headers(),
  });
}

export const listFloorRoom = ({buildingId:building_id, floorId:floor_id, offset, limit, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}/rooms`, {
    ...querystring({offset, limit, pagination}),
    ...headers(),
  });
}

export const updateRoom = ({buildingId:building_id, floorId:floor_id, roomId:room_id, name, rmsId:rms_id, allowKeytag:allow_keytag, advertiseStrength:advertise_strength, connectedStrength:connected_strength}) => {
  let data = removeNullInObject({name, rms_id});
  data = {...data, allow_keytag, ...allow_keytag && {advertise_strength, connected_strength}};
  return request.put(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}/rooms/${room_id}`,
    data,
    headers(),
  );
}

export const deleteRoom = ({buildingId:building_id, floorId:floor_id, roomId:room_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/buildings/${building_id}/floors/${floor_id}/rooms/${room_id}`, headers());
}

// commonroom
export const listCommonroom = ({buildingId:building_id, offset=0, limit=10}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/commonrooms`, {
    ...querystring({building_id, offset, limit}),
    ...headers(),
  });
}

export const listCommonroomDoorlock = ({buildingId:building_id, type='commonroom', offset=0, limit=10}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/doorlocks`, {
    ...querystring({building_id, type, offset, limit}),
    ...headers(),
  });
}

// doorlock
export const selectDoorlock = ({doorlockId:doorlock_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/doorlocks/${doorlock_id}`, headers());
}

export const listDoorlock = ({buildingId:building_id, floorId:floor_id, name, serial, type, status, fwType:fw_type, fwVersion:fw_version, sort, order, offset=0, limit=10, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/doorlocks`, {
    ...querystring({...building_id && {building_id}, ...floor_id && {floor_id}, ...name && {name}, serial, ...type && {type}, ...status && {status}, ...fw_type && {fw_type}, ...fw_version && {fw_version}, ...sort && {sort}, ...order && {order}, offset, limit, pagination}),
    ...headers(),
  });
}

export const uninstallDoorlock = ({doorlockId:doorlock_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/doorlocks/${doorlock_id}`, headers());
}

export const listDoorlockLog = ({doorlockId:doorlock_id, logType:log_type, sort, order, offset=0, limit=10, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/doorlocks/${doorlock_id}/logs`, {
    ...querystring({...log_type && {log_type}, offset, limit, pagination, ...sort && {sort}, ...order && {order},}),
    ...headers(),
  });
}

export const listDoorlockBatteryLog = ({doorlockId:doorlock_id, startAt:start_date, endAt:end_date}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/doorlocks/${doorlock_id}/battery_history`, {
    ...querystring({...start_date && {start_date}, ...end_date && {end_date}}),
    ...headers(),
  });
}

// booking
export const createBooking = ({userName:user_name, phoneNumber:phone_number, roomIds:room_ids, commonroomIds:commonroom_ids, checkinAt:checkin_at, checkoutAt:checkout_at, desc}) => {
  const data = {user_name, phone_number, room_ids, commonroom_ids, checkin_at, checkout_at, desc};
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings`,
    data,
    headers(),
  );
}

export const createBookingByExcelUpload = (formData) => {
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings/bulk`,
    formData,
    headers({'Content-Type': 'multipart/form-data'}),
  );
}

export const selectBooking = ({bookingId:booking_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}`, headers());
}

export const listBooking = ({buildingId:building_id, roomName:room_name, phoneNumber:phone_number, startAt:checkin_at, endAt:checkout_at, sort, order, offset, limit, date_filter_type="SET_DATE"}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/bookings`, {
    ...querystring({...building_id && {building_id}, ...room_name && {room_name}, ...phone_number && {phone_number}, ...checkin_at && {checkin_at}, ...checkout_at && {checkout_at}, ...sort && {sort}, ...order && {order}, date_filter_type, offset, limit}),
    ...headers(),
  });
}

export const listBookingDummy = () => {
  return {
    data: {
      total: 35,
      items: [
        {id: '1', room_name: '101', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '2', room_name: '102', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '3', room_name: '103', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: []},
        {id: '4', room_name: '104', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: []},
        {id: '5', room_name: '105', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '6', room_name: '106', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '7', room_name: '107', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '8', room_name: '108', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: [1]},
        {id: '9', room_name: '109', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'expired', cardkeys: [], mobilekeys: [1], pincodes: []},
        {id: '10', room_name: '201', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: [1]},
        {id: '11', room_name: '202', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: []},
        {id: '12', room_name: '203', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1,2], pincodes: [1]},
        {id: '13', room_name: '204', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [], pincodes: [1]},
        {id: '14', room_name: '205', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [], pincodes: [1]},
        {id: '15', room_name: '206', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: [1]},
        {id: '16', room_name: '207', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '17', room_name: '208', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '18', room_name: '209', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: [1]},
        {id: '19', room_name: '301', user_name: '', checkin_at: '', checkout_at: '', status: 'cleaning', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '20', room_name: '302', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '21', room_name: '303', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'expired', cardkeys: [1], mobilekeys: [1], pincodes: []},
        {id: '22', room_name: '304', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '23', room_name: '305', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1,2], pincodes: []},
        {id: '24', room_name: '306', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: [1]},
        {id: '25', room_name: '307', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: []},
        {id: '26', room_name: '308', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: []},
        {id: '27', room_name: '309', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: []},
        {id: '28', room_name: '401', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '29', room_name: '402', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '30', room_name: '403', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: [1]},
        {id: '31', room_name: '404', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: [1]},
        {id: '32', room_name: '405', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '33', room_name: '406', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        {id: '34', room_name: '407', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        {id: '35', room_name: '408', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [], mobilekeys: [1], pincodes: []},
        {id: '36', room_name: '409', user_name: '', checkin_at: '', checkout_at: '', status: 'cleaning', cardkeys: [], mobilekeys: [], pincodes: []},
        // {room_name: '501', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [1], pincodes: [1]},
        // {room_name: '502', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
        // {room_name: '503', user_name: '홍길동', checkin_at: '21.03.26', checkout_at: '21.03.27', status: 'issued', cardkeys: [1], mobilekeys: [], pincodes: [1]},
        // {room_name: '504', user_name: '', checkin_at: '', checkout_at: '', status: '', cardkeys: [], mobilekeys: [], pincodes: []},
      ],
    },
  };
}

export const updateBooking = ({bookingId:booking_id, userName:user_name, phoneNumber:phone_number, checkinAt:checkin_at, checkoutAt:checkout_at, desc}) => {
  let data = removeNullInObject({user_name, phone_number, desc});
  data = {...data, checkin_at, checkout_at};
  return request.put(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}`,
    data,
    headers(),
  );
}

export const cancelBooking = ({bookingId:booking_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}`, headers());
}

// userkey
export const issueUserMobilekey = ({bookingId:booking_id, userName:user_name, phoneNumber:phone_number, isNew:is_new, checkinAt:checkin_at, checkoutAt:checkout_at}) => {
  const data = {user_name, phone_number, is_new, checkin_at, checkout_at};
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}/exchangekeys`,
    data,
    headers(),
  );
}

export const deleteUserMobilekey = ({bookingId:booking_id, keyId:key_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}/mobilekeys/${key_id}`, headers());
}

export const issueUserPincode = ({bookingId:booking_id, userName:user_name, phoneNumber:phone_number, type, isNew:is_new, checkinAt:checkin_at, checkoutAt:checkout_at}) => {
  const data = {user_name, phone_number, type, is_new, checkin_at, checkout_at};
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings/${booking_id}/pincodes`,
    data,
    headers(),
  );
}

// sms
export const sendSMS = ({phoneNumber:phone_number, message}) => {
  const data = {phone_number, message};
  return request.post(`/multifamily/hotels/${getHotelId()}/sms`,
    data,
    headers(),
  );
}

export const notifyMobilekey = ({bookingId, userId}) => {
  const data = {};
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings/${bookingId}/mobilekeys/${userId}/notify`,
    data,
    headers(),
  );
}

export const notifyPincode = ({bookingId, pincodeId}) => {
  const data = {};
  return request.post(`/multifamily/hotels/${getHotelId()}/bookings/${bookingId}/pincodes/${pincodeId}/notify`,
    data,
    headers(),
  );
}

// staff
export const createStaff = ({name, phoneNumber:phone_number, role}) => {
  const data = {name, phone_number, role};
  return request.post(`/multifamily/hotels/${getHotelId()}/staffs`,
    data,
    headers(),
  );
}

export const selectStaff = ({staffId:staff_id}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/staffs/${staff_id}`, headers());
}

export const listStaff = ({name, role, status, offset, limit, pagination=true}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/staffs`, {
    ...querystring({...name && {name}, ...role && {role}, ...status && {status}, offset, limit, pagination}),
    ...headers(),
  });
}

export const updateStaff = ({staffId:staff_id, name, role}) => {
  const data = removeNullInObject({name, role});
  return request.put(`/multifamily/hotels/${getHotelId()}/staffs/${staff_id}`,
    data,
    headers(),
  );
}

export const deleteStaff = ({staffId:staff_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/staffs/${staff_id}`, headers());
}

// staffkey
export const issueStaffMobilekey = ({staffId:permission_id, roomIds:room_ids, commonroomIds:commonroom_ids, startAt:start_at, endAt:end_at}) => {
  const data = {permission_id, room_ids, commonroom_ids, start_at, end_at};
  return request.post(`/multifamily/hotels/${getHotelId()}/staffs/keys/mobilekey`,
    data,
    headers(),
  );
}

export const listStaffkey = ({staffId:staff_id, offset=0, limit=10}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/staffs/keys`, {
    ...querystring({staff_id, offset, limit}),
    ...headers(),
  });
}

export const deleteStaffMobilekey = ({keyId:key_id}) => {
  return request.delete(`/multifamily/hotels/${getHotelId()}/staffs/keys/${key_id}`, headers());
}

// report
export const listReport = ({reportType:report_type, buildingName:building_name, startAt:start_at, endAt:end_at}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/reports/${report_type}`, {
    ...querystring({...building_name && {building_name}, ...start_at && {start_at}, ...end_at && {end_at}}),
    ...headers(),
  });
}